import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoute } from '../../../routing/types/app-route';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private router = inject(Router);

    public navigateToNotFound() {
        return this.navigateTo(AppRoute.NotFound);
    }

    public navigateToUnauthorized() {
        return this.navigateTo(AppRoute.Unauthorized);
    }

    public navigateToLogin() {
        return this.navigateTo(AppRoute.Login);
    }

    private navigateTo(route: AppRoute): void {
        this.router.navigate([ '/' + route ]);
    }
}
